<template>
  <router-view v-bind="$attrs" />
</template>

<script>
import * as R from 'ramda'
import VueRouter from 'vue-router'
import Loader from './Loader.vue'

function metaValue(name) {
  const tag = document.head.querySelector(`meta[name="${name}"]`)
  return tag && tag.content
}

const metaId = metaValue('tizra-id')
let originalPathId

function loaderProps(route) {
  const {
    params: {pathId, pathNum},
    query,
  } = route

  if (!originalPathId) {
    originalPathId = pathId
  }

  const tizraId =
    query['tizra-id'] || (pathId === originalPathId && metaId) || pathId || '' // Loader will fatal

  const pageNum = parseInt(
    query['page-num'] || pathNum || 0, // Loader will replace
  )

  return {
    tizraId,
    pageNum,
  }
}

export default {
  name: 'Router',

  // App passes height, width, etc. which we'll pass to Loader via
  // $attrs in viewProps
  inheritAttrs: false,

  // Define routes for the App to set tizraId and pageNum. The server
  // loads the reader with either with either tizra-id or url-id in the
  // path, so the App will check for <meta name="tizra-id"> before
  // falling back to the id discovered here.
  router: new VueRouter({
    mode: 'history',
    routes: [
      {
        name: 'page',
        path: '/:pathId([^/]+)/:pathNum(\\d+)',
        component: Loader,
        props: loaderProps,
      },
      {
        name: 'buriedPage',
        path: '/*/:pathId([^/]+)/:pathNum(\\d+)',
        component: Loader,
        props: loaderProps,
      },
      {
        name: 'staticPage',
        path: '/',
        component: Loader,
        props: loaderProps,
      },
    ],
    caseSensitive: true,
  }),

  methods: {
    /**
     * Given a page number, return the href to that page.
     */
    linkToPage(pageNum, {hash = '', query = {}} = {}) {
      switch (this.$route.name) {
        case 'staticPage':
          return this.$router.resolve({
            ...this.$route,
            query: {
              ...R.pick(['tizra-id'], this.$route.query),
              'page-num': pageNum,
              ...query,
            },
            hash,
          }).href
        case 'page':
        case 'buriedPage':
          return this.$router.resolve({
            ...this.$route,
            params: {
              ...this.$route.params,
              pathNum: pageNum,
            },
            query,
            hash,
          }).href
        default:
          // This is an error, but not worth tripping over here.
          return `#${pageNum}`
      }
    },
  },

  provide() {
    return {
      linkToPage: this.linkToPage,
    }
  },
}
</script>
